// <?xml version="1.0" encoding="UTF-8"?>
// <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 382.68 70.87">
//   <!-- Generator: Adobe Illustrator 29.8.2, SVG Export Plug-In . SVG Version: 2.1.1 Build 3)  -->
//   <defs>
//     <style>
//       .st0 {
//         fill: #e4032e;
//       }

//       .st1 {
//         fill: #8d8e8e;
//       }

//       .st2 {
//         fill: #fff;
//       }

//       .st3 {
//         fill: #e73439;
//       }

//       .st4 {
//         display: none;
//       }

//       .st5 {
//         fill: #ea4a90;
//       }
//     </style>
//   </defs>
//   <g id="Calque_2" class="st4">
//     <rect class="st5" x="-14.17" y="-14.84" width="411.02" height="99.87"/>
//   </g>
//   <g id="Layer_1">
//     <g>
//       <path class="st1" d="M208.39,41.14c0,2.83-.88,5.13-2.64,6.9s-4.05,2.65-6.88,2.65h-30.15v-7.63h24.41c.63,0,1.17-.17,1.62-.5s.67-.81.67-1.42-.23-1.05-.69-1.39c-.46-.34-.99-.5-1.6-.5h-14.86c-2.85,0-5.15-.88-6.91-2.64s-2.64-4.06-2.64-6.91.88-5.15,2.64-6.9,4.06-2.62,6.91-2.62h30.11v7.63h-24.41c-.59,0-1.12.17-1.59.52-.47.35-.7.8-.7,1.38s.24,1.07.73,1.43c.43.33.94.49,1.56.49h14.89c2.85,0,5.15.88,6.9,2.62,1.75,1.75,2.62,4.05,2.62,6.9Z"/>
//       <path class="st1" d="M254.93,50.69h-12.2v-15.26l-9.15,9.15-9.15-9.15v15.26h-12.2v-22.89c0-2.3.7-4.14,2.09-5.54s3.24-2.09,5.54-2.09c1.42,0,3.08.76,4.98,2.29l8.76,8.76,8.79-8.76c1.87-1.53,3.52-2.29,4.94-2.29,2.3,0,4.14.7,5.54,2.09s2.09,3.24,2.09,5.54v22.89Z"/>
//       <path class="st1" d="M296.52,50.69h-12.2v-11.44h-6.87v-7.63h6.87v-3.81h-4.58c-1.38,0-2.53,1.27-3.45,3.81l-6.87,19.07h-12.6l6.13-16.78c3.34-9.15,8.93-13.73,16.78-13.73h7.23c3.42,0,5.96.88,7.63,2.65,1.28,1.34,1.92,3,1.92,4.97v22.89Z"/>
//       <path class="st1" d="M340,50.69h-12.97v-9.55c0-1.26-.76-1.89-2.29-1.89h-12.2v11.44h-12.2v-19.07h24.41c.63,0,1.17-.17,1.62-.5s.67-.81.67-1.42-.23-1.05-.69-1.39c-.46-.34-.99-.5-1.6-.5h-24.41v-7.63h30.15c2.85,0,5.15.87,6.9,2.62,1.75,1.75,2.62,4.05,2.62,6.9,0,2.38-.88,4.29-2.65,5.74,1.77,1.44,2.65,3.35,2.65,5.71v9.55Z"/>
//       <path class="st1" d="M374.32,27.8h-9.15v22.89h-12.2v-22.89h-9.15v-7.63h30.51v7.63Z"/>
//     </g>
//     <rect class="st0" x="152.48" y="31.57" width="8.05" height="4.02"/>
//     <rect class="st0" x="152.48" y="36.65" width="8.05" height="4.02"/>
//     <rect class="st0" x="152.48" y="41.74" width="8.05" height="4.02"/>
//     <rect class="st0" x="152.48" y="46.82" width="8.05" height="4.02"/>
//     <polygon class="st0" points="89.1 20.02 81.03 20.02 75.3 28.19 85.54 28.19 88.36 32.01 72.97 32.01 60.03 50.9 68.14 50.9 77.11 39.01 93.13 39.01 101.94 50.9 110.11 50.9 89.1 20.02"/>
//     <path class="st0" d="M108.52,19.91l16.13,22.71,15.49-22.71h9.34l-21.01,30.99h-8.06l-21.01-31.09,9.13.1Z"/>
//     <path class="st0" d="M160.46,20.02v8.17h-7.96v-8.17h7.96Z"/>
//     <g>
//       <path class="st0" d="M56.09,52.44H12.8c-2.46,0-4.45-1.99-4.45-4.45v-29.57h43.33c2.46,0,4.45,1.99,4.45,4.45l-.04,29.57Z"/>
//       <path class="st2" d="M53.59,22.49v27.95h-6.66v-22.59l-10.29,22.59h-6.03l-12-22.57h-7.51v-7.54h11.8l10.81,20.8,8.87-20.8h8.83c1.16,0,2.18,1,2.18,2.16Z"/>
//       <path class="st2" d="M18.57,50.22h-5.22c-1.44,0-2.25-1.14-2.25-2.19v-1.22h7.48v3.41Z"/>
//       <rect class="st2" x="11.1" y="42.34" width="7.48" height="3.41"/>
//       <rect class="st2" x="11.1" y="37.87" width="7.48" height="3.41"/>
//       <rect class="st2" x="11.1" y="33.4" width="7.48" height="3.41"/>
//       <rect class="st2" x="11.1" y="28.95" width="7.48" height="3.41"/>
//       <path class="st3" d="M8.35,18.43h4.45"/>
//     </g>
//   </g>
// </svg>

import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_mavismart_logo_red_and_grey: SvgIconData = {
  viewBox: '0 0 382.68 70.87',
  element: (
    <>
      <g>
        <g>
          <path
            fill="#8d8e8e"
            d="M208.39,41.14c0,2.83-.88,5.13-2.64,6.9s-4.05,2.65-6.88,2.65h-30.15v-7.63h24.41c.63,0,1.17-.17,1.62-.5s.67-.81.67-1.42-.23-1.05-.69-1.39c-.46-.34-.99-.5-1.6-.5h-14.86c-2.85,0-5.15-.88-6.91-2.64s-2.64-4.06-2.64-6.91.88-5.15,2.64-6.9,4.06-2.62,6.91-2.62h30.11v7.63h-24.41c-.59,0-1.12.17-1.59.52-.47.35-.7.8-.7,1.38s.24,1.07.73,1.43c.43.33.94.49,1.56.49h14.89c2.85,0,5.15.88,6.9,2.62,1.75,1.75,2.62,4.05,2.62,6.9Z"
          />
          <path
            fill="#8d8e8e"
            d="M254.93,50.69h-12.2v-15.26l-9.15,9.15-9.15-9.15v15.26h-12.2v-22.89c0-2.3.7-4.14,2.09-5.54s3.24-2.09,5.54-2.09c1.42,0,3.08.76,4.98,2.29l8.76,8.76,8.79-8.76c1.87-1.53,3.52-2.29,4.94-2.29,2.3,0,4.14.7,5.54,2.09s2.09,3.24,2.09,5.54v22.89Z"
          />
          <path
            fill="#8d8e8e"
            d="M296.52,50.69h-12.2v-11.44h-6.87v-7.63h6.87v-3.81h-4.58c-1.38,0-2.53,1.27-3.45,3.81l-6.87,19.07h-12.6l6.13-16.78c3.34-9.15,8.93-13.73,16.78-13.73h7.23c3.42,0,5.96.88,7.63,2.65,1.28,1.34,1.92,3,1.92,4.97v22.89Z"
          />
          <path
            fill="#8d8e8e"
            d="M340,50.69h-12.97v-9.55c0-1.26-.76-1.89-2.29-1.89h-12.2v11.44h-12.2v-19.07h24.41c.63,0,1.17-.17,1.62-.5s.67-.81.67-1.42-.23-1.05-.69-1.39c-.46-.34-.99-.5-1.6-.5h-24.41v-7.63h30.15c2.85,0,5.15.87,6.9,2.62,1.75,1.75,2.62,4.05,2.62,6.9,0,2.38-.88,4.29-2.65,5.74,1.77,1.44,2.65,3.35,2.65,5.71v9.55Z"
          />
          <path fill="#8d8e8e" d="M374.32,27.8h-9.15v22.89h-12.2v-22.89h-9.15v-7.63h30.51v7.63Z" />
        </g>
        <rect fill="#e4032e" x="152.48" y="31.57" width="8.05" height="4.02" />
        <rect fill="#e4032e" x="152.48" y="36.65" width="8.05" height="4.02" />
        <rect fill="#e4032e" x="152.48" y="41.74" width="8.05" height="4.02" />
        <rect fill="#e4032e" x="152.48" y="46.82" width="8.05" height="4.02" />
        <polygon
          fill="#e4032e"
          points="89.1 20.02 81.03 20.02 75.3 28.19 85.54 28.19 88.36 32.01 72.97 32.01 60.03 50.9 68.14 50.9 77.11 39.01 93.13 39.01 101.94 50.9 110.11 50.9 89.1 20.02"
        />
        <path
          fill="#e4032e"
          d="M108.52,19.91l16.13,22.71,15.49-22.71h9.34l-21.01,30.99h-8.06l-21.01-31.09,9.13.1Z"
        />
        <path fill="#e4032e" d="M160.46,20.02v8.17h-7.96v-8.17h7.96Z" />
        <g>
          <path
            fill="#e4032e"
            d="M56.09,52.44H12.8c-2.46,0-4.45-1.99-4.45-4.45v-29.57h43.33c2.46,0,4.45,1.99,4.45,4.45l-.04,29.57Z"
          />
          <path
            fill="#fff"
            d="M53.59,22.49v27.95h-6.66v-22.59l-10.29,22.59h-6.03l-12-22.57h-7.51v-7.54h11.8l10.81,20.8,8.87-20.8h8.83c1.16,0,2.18,1,2.18,2.16Z"
          />
          <path fill="#fff" d="M18.57,50.22h-5.22c-1.44,0-2.25-1.14-2.25-2.19v-1.22h7.48v3.41Z" />
          <rect fill="#fff" x="11.1" y="42.34" width="7.48" height="3.41" />
          <rect fill="#fff" x="11.1" y="37.87" width="7.48" height="3.41" />
          <rect fill="#fff" x="11.1" y="33.4" width="7.48" height="3.41" />
          <rect fill="#fff" x="11.1" y="28.95" width="7.48" height="3.41" />
          <path fill="#e73439" d="M8.35,18.43h4.45" />
        </g>
      </g>
    </>
  ),
};
